import React from 'react';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';

interface DeleteDocumentDialogProps {
  open: boolean;
  documentName?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteDocumentDialog: React.FC<DeleteDocumentDialogProps> = ({
  open,
  documentName,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      icon={icons.exclamation}
      open={open}
      positiveLabel="Sim"
      negativeAction={onClose}
      negativeLabel="Não"
      positiveAction={onConfirm}
      message={`Deseja excluir o documento ${documentName}`}
    />
  );
};

export default DeleteDocumentDialog;
